module.exports = __webpack_public_path__ + "img/icon04.b0087ce8.png";